import { fromIso8601DateTime } from "@/shared/lib/datetime";
import type { FreightMatching } from "@x-mile/api-contract";

export type DraftOfferCargo = Pick<
  FreightMatching.schemas.OfferCargo,
  "id" | "deadlineAt" | "process" | "company" | "createdAt"
>;
export type DeliveryProposalOfferCargo = Pick<
  FreightMatching.schemas.OfferCargo,
  "id" | "rejection" | "process" | "company" | "createdAt"
>;
export type ContractOfferCargo = Pick<
  FreightMatching.schemas.OfferCargo,
  | "id"
  | "rejection"
  | "process"
  | "stage"
  | "company"
  | "sourceOfferCargoId"
  | "createdAt"
>;
export type OfferCargoProcess = {
  draftOfferCargo: DraftOfferCargo;
  deliveryProposalOfferCargos: DeliveryProposalOfferCargo[];
  contractOfferCargos: ContractOfferCargo[];
};

export const OfferCargoRejectionReasonLabels: {
  reason: FreightMatching.schemas.OfferRejectionReason;
  label: string;
}[] = [
  {
    reason: "chose_another_offer",
    label: "他に車両が見つかったため",
  },
  {
    reason: "shipping_fee",
    label: "運賃が条件と合わないため",
  },
  {
    reason: "schedule",
    label: "積込/取卸の日時が条件と合わないため",
  },
  {
    reason: "others",
    label: "その他",
  },
];
export const getOfferCargoRejectionReasonLabel = (
  reason: FreightMatching.schemas.OfferRejectionReason,
): string => {
  const reasonLabel = OfferCargoRejectionReasonLabels.find(
    (reasonLabel) => reasonLabel.reason === reason,
  );
  if (!reasonLabel) {
    throw new Error(`unknown reason: ${reason}`);
  }
  return reasonLabel.label;
};

export const calculateLatestRejectedContract = (
  offerCargoProcess: OfferCargoProcess,
): ContractOfferCargo | undefined => {
  return offerCargoProcess.contractOfferCargos
    .filter((contract) => !!contract.rejection)
    .sort(
      (a, b) =>
        fromIso8601DateTime(b.createdAt).getTime() -
        fromIso8601DateTime(a.createdAt).getTime(),
    )[0];
};
